export default __webpack_public_path__ + "static/media/file-audio.664b6501.svg";